import {z} from '@hono/zod-openapi';

export const advertisingPreflightIssueSchema = z
  .object({
    kind: z.enum(['field', 'vehicle-taxonomy', 'equipment-taxonomy', 'configuration']),
    reasonCode: z.string().min(1),
    mappingIdentifier: z.string().nullable(),
    targetPath: z.string().nullable(),
    sourcePaths: z.array(z.string()),
    blockingDimension: z
      .enum(['vehicleType', 'make', 'model', 'fuel', 'hybrid', 'body', 'transmission'])
      .nullable(),
  })
  .openapi('AdvertisingPreflightIssue');

export type AdvertisingPreflightIssue = z.infer<typeof advertisingPreflightIssueSchema>;
